import { messageFromAxiosErrorPayload } from './axiosErrorMessage';

export function messageFromEmployerVerificationHttpError(err: unknown): string {
  const ax = err as {
    message?: string;
    code?: string;
    response?: { status?: number; data?: unknown };
  };
  const msg = typeof ax.message === 'string' ? ax.message : '';
  if (ax.code === 'ECONNREFUSED' || msg.includes('ECONNREFUSED')) {
    return 'Cannot reach employer-verification on the proxy target. Start employer-verification (`npm run dev` in employer-verification/; default PORT=5000) and set `VITE_EMPLOYER_VERIFICATION_PROXY_TARGET` or `VITE_EMPLOYER_VERIFICATION_API_BASE` in apps/admin/.env to that same origin.';
  }
  if (ax.code === 'ERR_NETWORK' || msg === 'Network Error') {
    return 'Network error talking to employer-verification (CORS/offline/wrong port). Confirm the EV service is listening and the Vite proxy path /api/employer-verification is configured.';
  }
  const data = ax.response?.data;
  const parsed = messageFromAxiosErrorPayload(data);
  if (parsed) return parsed;
  if (data && typeof data === 'object') {
    const o = data as Record<string, unknown>;
    if (typeof o.error === 'string' && o.error.trim()) return o.error.trim();
  }
  return msg.trim() || 'Request failed.';
}
